import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./router";
import App from "./App.vue";
import WebTitle from "./directives/WebTitle";
import ElementUI from "element-ui";
// import "element-ui/lib/theme-chalk/index.css";
import { getStorage, setStorage, removeStorage } from "@/common/js/localstorage";
import VueQriously from "vue-qriously";

import Api from "@/api/base";

let httpRoutes = [];

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(ElementUI);
Vue.use(VueQriously); // 生成二维码
Vue.directive("web-title", WebTitle);
import BaseApi from "@/api/base";
Vue.directive("pre-handle-on-demand", {
  bind(el, binding) {
    var fn = binding.value;
    function loop() {
      let data = getStorage("user");
      let school_id = 0;
      if (data.area_type == 2) {
        school_id = data.area_id;
      }
      BaseApi.getVideoFluxFree(school_id)
        .then((res) => {
          if (res.data.status !== 0) {
            throw res.data.info.detail || "无法获取点播剩余流量";
          }
          if (res.data.data) {
            fn();
          } else {
            throw "点播流量不足，请联系管理员！";
          }
        })
        .catch((e) => {
          Vue.prototype.$message.error(e);
        });
    }
    el.addEventListener("click", loop);
  }
});
Vue.directive("pre-handle-live", {
  bind(el, binding) {
    var fn = binding.value;
    function loop() {
      let data = getStorage("user");
      let school_id = 0;
      if (data.area_type == 2) {
        school_id = data.area_id;
      }
      BaseApi.getLiveFluxFree(school_id)
        .then((res) => {
          if (res.data.status !== 0) {
            throw res.data.info.detail || "无法获取直播剩余流量";
          }
          if (res.data.data) {
            fn();
          } else {
            throw "直播流量不足，请联系管理员！";
          }
        })
        .catch((e) => {
          Vue.prototype.$message.error(e);
        });
    }
    el.addEventListener("click", loop);
  }
});
//重写 VueRouter 原型链 push 方法的 catch，使不做报错停止执行处理
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function(location) {
  return originalPush.call(this, location).catch((err) => err);
};

let router;

initConf();

// 获取学校网址 pathname，根据 pathname 获取学校 id
// 用 pathname 匹配微应用的入口前缀
async function initConf() {
  // 判断当前路径是否匹配 /school/xxxx/ 代表是学校地址模式
  const schoolUrlMessageArr = /\/school\/.*?\//.exec(location.href);
  // 判断当前路径是否匹配 /area/xxxx/ 代表是区域地址模式
  const areaUrlMessageArr = /\/area\/.*?\//.exec(location.href);
  if (areaUrlMessageArr || schoolUrlMessageArr || location.pathname == "/") {
    // 先根据 pathname 获取 school_id，并保存在 localstorage
    let pathname = window.location.pathname;
    setStorage("pathname", pathname);
    //暂时将 pathname 弄成全路径
    // pathname = window.baseUrl + pathname

    Api.getOrgDetailByPathname(pathname)
      .then((response) => {
        if (response.data.status === 0) {
          let school = response.data.data;
          // 调试
          // school.org_id = 1
          // school.org_type = 1
          // 这里 school 是笼统的代称，代表学校或区域
          setStorage("school", school);
          initApp(school.org_id);
        } else {
          console.log(response.data.info.message);
          //清除storage
          removeStorage("user");
          initConf();
          window.open(window.location.origin + "/#/login", "_self");
        }
      })
      .catch((error) => {
        console.log(error);
        //清除storage
        removeStorage("user");
        initConf();
        window.open(window.location.origin + "/#/login", "_self");
      });
  }
}

async function initApp(schoolId) {
  //保证先获取到前台子应用路由列表
  const data = getStorage("school").org_type === 1 ? { area_id: schoolId || 0 } : { school_id: schoolId || 0 };
  Api.getSubappRouteList(data).then((response) => {
    if (response.data.status === 0) {
      httpRoutes = response.data.data.list;

      routes[0].children.push(...httpRoutes);
    }

    router = new VueRouter({
      routes
    });

    // router.beforeEach((to, from, next) => {
    //   // `to` 和 `from` 是即将进入和离开的路由对象
    //   // `next` 是一个函数，用于控制路由的跳转
    //   if (to.path.indexOf("micro") != -1) {
    //     Api.verifyPagePermisson({ uri: to.path })
    //       .then((res) => {
    //         if (res.data.status == 0) {
    //           next();
    //         } else {
    //           Vue.prototype.$message.error(res.data.info.message);
    //           next(false);
    //         }
    //       })
    //       .catch((error) => {
    //         Vue.prototype.$message.error(error);
    //         next(false);
    //       });
    //   } else {
    //     next();
    //   }
    // });

    //中央事件总线
    const bus = new Vue();
    Vue.prototype.$bus = bus;

    new Vue({
      router,
      render: (h) => h(App)
    }).$mount("#app");
  });
}
